import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import Table from "../../../../components/Table";
import BaseListPage from "../../../../base/BaseListPage";
import ScheduleTablePresenter from "../forms/employment/tables/ScheduleTablePresenter";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import schedule from "../../../ReferenceTable/schedule-template/schedule/shdedule-form/schedule-page/scheduleSchema.json";
import { InputFactory } from "nq-component";

export default class ScheduleAssignTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ScheduleTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      scheduleTemplate: [],
      assignSchedule: props?.scheduleObj || {},
      object: [],
      objects: [],
      count: 0,
      limit: 20,
      current: 1,
      orgStructure: [
        "regions",
        "offices",
        "divisions",
        "sections",
        "units",
        "plantilla",
      ],
    };
  }

  getLastNonEmptyField = (source) => {
    let result = "";
    let index = -1;

    ["region", "office", "division", "section", "unit", "cluster"].forEach(
      (field, i) => {
        if (source[field] && source[field] !== "") {
          result = source[field];
          index = i;
        }
      },
    );

    return { result, index };
  };

  async componentDidMount() {
    this.presenter.componentDidMount();
    // console.log("PROPS: ", this.props.scheduleObj);
    const { orgStructure } = this.state;
    const currentUser = this.getCurrentUser();
    const employee = await getObjectUseCase().execute(
      "employees",
      currentUser?.employee?.id,
      {
        params: {
          select: [
            "region",
            "office",
            "division",
            "section",
            "unit",
            "cluster",
          ],
        },
      },
    );
    const lastNoneEmpty = this.getLastNonEmptyField(employee);
    if (!employee || !lastNoneEmpty.result) return;
    // const org = orgStructure[lastNoneEmpty.index]
    let where = {
      status: "active",
      cluster: "undefined",
    };
    // console.log("orgStructure: ", orgStructure[lastNoneEmpty?.index]);
    if (lastNoneEmpty?.result) {
      where = {
        status: "active",
        [orgStructure[lastNoneEmpty?.index]]: lastNoneEmpty?.result,
      };
    }
    const schedules = await findObjectUseCase().execute(
      this.getCollectionName(),
      {
        where,
      },
    );
    // console.log("org: ", orgStructure[lastNoneEmpty.index]);
    // console.log("USER: ", currentUser);
    // console.log("emp: ", employees);
    // console.log("last: ", lastNoneEmpty);
    // console.log("SCEDYLE: ", schedules);
    this.setState({
      scheduleTemplate: schedules,
      // selectedSchedule: this.props.object.selectedSchedule,
    });
    // const assignSchedule = sessionStorage.getItem("selectedSchedule");
    // this.props.assignSchedule(assignSchedule);
  }

  getCollectionName() {
    return "schedule_template";
  }

  // delete function
  // async handleDeleteData(id) {
  //   await this.presenter.deleteObjectUseCase.execute("schedule", id);
  //   this.refetchData();
  // }
  // async refetchData() {
  //   // const assignSchedule = sessionStorage.getItem("selectedSchedule");
  //   // const schedules = await findObjectUseCase().execute(
  //   //   this.getCollectionName(),
  //   //   {
  //   //     where: { status: "active" },
  //   //   }
  //   // );
  //   // const object = schedule.filter((data) => data.name === assignSchedule);
  //   // this.setState({ object });
  // }

  async handleScheduleChange(assignSchedule) {
    this.setState({
      assignSchedule,
    });
    // sessionStorage.setItem("selectedSchedule", assignSchedule);
    console.log("assignSchedule: ", assignSchedule);
    this.props.assignSchedule(assignSchedule);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  getCurrent() {
    return this.state.selectedSchedule || "";
  }

  render() {
    const schema = schedule;
    const {
      object,
      scheduleTemplate,
      count,
      current,
      limit,
      loading,
      assignSchedule,
    } = this.state;
    // console.log("props: ", this.props);
    return (
      <>
        <div className="m-4">
          <div className="col-lg-5 p-1 mb-4">
            {this.props.isForView ? (
              <>
                {/* <h2>{assignSchedule?.name}</h2> */}
                <InputFactory
                  value={assignSchedule?.name}
                  type="String"
                  disabled={true}
                />
              </>
            ) : (
              <SearchSelect
                value={assignSchedule.name}
                onClickClear={() => {
                  this.handleScheduleChange("");
                }}
                focus={true}
                onChange={this.handleScheduleChange.bind(this)}
                options={scheduleTemplate.map((sched) => {
                  return {
                    label: sched.name,
                    value: {
                      name: sched.name,
                      id: sched.id,
                      scheduleArray: sched.scheduleArray,
                      startingDate: sched.startingDate,
                      selectedOption: sched.selectedOption,
                      sequence: sched.sequence,
                    },
                  };
                })}
              />
            )}
          </div>

          <Table
            // objectId={this.handleDeleteData.bind(this)}
            // refetch={this.refetchData.bind(this)}
            progress={loading}
            fields={schema.fields}
            objects={assignSchedule.scheduleArray}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            // actionsList={[
            //   {
            //     label: <i className="bi bi-trash" />,
            //     actionType: "delete",
            //   },
            // ]}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["id", "Created At", "Updated At", "name"],
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
